const backLinks = document.body.querySelectorAll('.back-link');
for (const backLink of backLinks) {
  backLink.addEventListener('click', goBack);
}
function goBack (e) {
  const referrer = document.referrer;

  // Check if referrer exists and belongs to the same domain
  if (referrer && new URL(referrer).hostname === window.location.hostname) {
    e.preventDefault();
    window.history.back();
  }
}
